import React, { useEffect, useState } from 'react'
import { ArrowBack } from '@mui/icons-material'
import moment from 'moment'
import { useGetRequest } from '../../../shared/hooks/requests'
import { TENANT_DEVICE_ANALYTICS } from '../../../shared/utils/urls'
import { AttendanceBlank } from './AttendanceModal'

const cols = [
    { id: 1, title: 'AppSource' },
    { id: 2, title: 'AppVersionCode' },
    { id: 3, title: 'AppVersionName' },
    { id: 4, title: 'CreatedAt' },
    { id: 5, title: 'DeviceName' },
    { id: 6, title: 'UniqueId' },
    { id: 7, title: 'UserId' },
]

export function DeviceAnalytics({ id, deviceId, startPeriod, endPeriod, onBack, model }) {
    const getAnalytics = useGetRequest()
    const [showAttendanceBlank, setShowAttendanceBlank] = useState('')
    const [selectedAttendanceData, setSelectedAttendanceData] = useState(null)
    const analytics = getAnalytics.response ? getAnalytics.response : null
    const attendances = analytics?.attendances ? analytics.attendances : []
    const loginHistory = analytics?.loginHistory ? analytics?.loginHistory : []

    console.log(loginHistory)

    useEffect(() => {
        getAnalytics.request({
            url: TENANT_DEVICE_ANALYTICS,
            params: {
                tenant_entity_id: id,
                start_date: startPeriod,
                end_date: endPeriod,
                device_id: deviceId,
            },
        })
    }, [])

    const handleDetailsClick = ({ category, label }) => {
        setSelectedAttendanceData({
            start_date: startPeriod,
            end_date: endPeriod,
            id,
            category,
            label,
        })
        setShowAttendanceBlank(true)
    }

    return (
        <div className="flex flex-col gap-6 w-full">
            {showAttendanceBlank && selectedAttendanceData ? (
                <AttendanceBlank
                    startDate={selectedAttendanceData.start_date}
                    endDate={selectedAttendanceData.end_date}
                    id={selectedAttendanceData.id}
                    category={selectedAttendanceData.category}
                    model={deviceId}
                    label={selectedAttendanceData.label}
                    onBack={() => setShowAttendanceBlank(false)}
                />
            ) : (
                <div className="w-full h-full flex flex-col  items-center gap-[30px]">
                    <div className="w-full p-[10px] bg-white rounded-[10px] flex items-center gap-[20px]">
                        <div className="py-[7px] px-[5px] flex items-center
                         justify-center rounded-[20px] bg-gray-200/50"
                        >
                            <ArrowBack
                                onClick={onBack}
                                className="cursor-pointer hover:text-main-100 transition"
                            />
                        </div>
                        <span className="text-[16px] font-[500] text-black">{model}</span>
                    </div>
                    <div className="w-full flex flex-col bg-white p-[15px] rounded-[10px] items-center gap-[10px]">
                        {[
                            { label: 'Fake Location Count',
                                value: attendances?.fakeLocationCount,
                                key: 3 },
                            { label: 'Broken Time Count',
                                value: attendances?.brokenTimeCount,
                                key: 1 },
                            { label: 'Green Count', value: attendances?.greenCount, key: 0 },
                            { label: 'Invalid Recognition Count',
                                value: attendances?.invalidRecognitionCount,
                                key: 5 },
                            { label: 'Same Coordinates Count',
                                value: attendances?.sameCoordinatesCount,
                                key: 2 },
                            { label: 'White Images Count',
                                value: attendances?.whiteImagesCount,
                                key: 4 },
                        ].map((item) => (
                            <div
                                key={item.key}
                                className="w-full flex items-center gap-[30px] justify-between"
                            >
                                <span className="text-[14px] font-[600] text-black/70">
                                    {item.label}
                                </span>
                                <div className="flex items-center gap-[100px]">
                                    <span className="text-gray-200 font-[600] text-[13px]">
                                        {item.value || 0}
                                    </span>
                                    <button
                                        className="px-[15px] py-[5px] rounded-[10px] text-[14px]
                                                 bg-main-100 text-white font-[500]"
                                        onClick={() => handleDetailsClick({ category: item.key,
                                            label: item.label,
                                            detailsClick: 'attendancesBlank' })}
                                    >
                                        Details
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="w-full flex flex-col bg-white rounded-[10px] p-[15px]">
                        {/* Table Headers */}
                        <div className="w-full flex items-center justify-between
                         pb-[10px] border-b border-gray-200/50 gap-[20px]"
                        >
                            {cols.map((item) => (
                                <div key={item.id} className="w-[11%] flex items-center justify-center">
                                    <span className="text-[14px] font-[600]
                                    text-black text-center w-full break-words"
                                    >
                                        {item.title}
                                    </span>
                                </div>
                            ))}
                        </div>

                        {/* Table Body */}
                        <div className="w-full max-h-[300px] overflow-auto flex flex-col items-center gap-[20px]">
                            {loginHistory?.map((item) => (
                                <div className="w-full flex items-center justify-between gap-[20px]">
                                    {[
                                        item.appSource,
                                        item.appVersionCode,
                                        item.appVersionName,
                                        moment(item.createdAt).format('YYYY-MM-DD:HH:mm'),
                                        item.deviceName,
                                        item.uniqueId,
                                        item.userId,
                                    ].map((val) => (
                                        <div className="w-[11%] flex items-center justify-center">
                                            <span className="text-[12px] font-[500]
                                            text-gray-200 text-center w-full break-words"
                                            >
                                                {val}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
